import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    logos: {
      display: 'flex',
      position: 'relative',
      zIndex: 4,
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 7,
      [muiTheme.breakpoints.down('sm')]: {
        flexDirection: 'row',
        marginTop: 0,
      },
    },
    campaignLogos: {
      [muiTheme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    logoStyles: {
      width: 101,
      marginLeft: muiTheme.spacing(2),

      [muiTheme.breakpoints.down('sm')]: {
        marginLeft: muiTheme.spacing(1.5),
        width: 'auto',
        display: 'flex',
        alignItems: 'center',
        '& a': {
          display: 'flex',
          alignItems: 'center',
        },
        '& img': {
          height: '18px',
          width: 'auto',
        },
      },
    },
    navJumplinks: {
      display: 'flex',

      '& ul': {
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'flex-end',

        '& li': {
          '& .MuiButton-label': {
            ...muiTheme.typography.body2,
            fontWeight: '500 !important',
          },
          '& button': {
            color: 'inherit',
            padding: '6px 14px',
            '&:before': {
              content: '""',
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: '0',
              left: '0',
              transition: 'opacity 150ms ease-in-out 0s',
              borderRadius: '4',
              opacity: 0,
              backgroundColor: 'rgb(0, 0, 0)',
            },
            '&:after': {
              content: '""',
              opacity: 0,
              height: '1px',
              width: '0%',
              bottom: 0,
              left: '50%',
              position: 'absolute',
              transform: 'translateX(-50%)',
              transition: 'opacity 150ms ease-in-out, width 250ms ease-in-out',
              backgroundColor: 'rgb(62, 192, 243)',
            },
          },
          '&:hover button:after': {
            width: 'calc(100% - 28px)',
            opacity: '1',
          },
          '&:hover, :active, :focus': {
            '& button:before': {
              opacity: '.1',
            },
          },
        },
      },
    },
    mobileLinks: {
      position: 'relative',
      zIndex: 4,
      paddingLeft: '10px',

      '& nav': {
        textAlign: 'left',

        '& h5': {
          paddingBottom: 30,
        },
      },
    },
    buttons: {
      alignSelf: 'center',
      display: 'flex',
      position: 'relative',
      zIndex: 4,
      [muiTheme.breakpoints.up('md')]: {
        padding: muiTheme.spacing(0, 1),
      },
      [muiTheme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
      '& .nav-btn': {
        [muiTheme.breakpoints.up('md')]: {
          margin: 'auto 0',

          '&:not(:first-of-type)': {
            marginLeft: muiTheme.spacing(1),
          },
        },

        '& > .MuiButtonBase-root': {
          padding: '0 19px',
          height: muiTheme.spacing(4),
          textDecoratoin: 'none',
          minWidth: 'unset',
        },
        '& .MuiButton-label': {
          ...muiTheme.typography.body2,
          fontWeight: '500 !important',
        },
      },
    },
    buttons2: {
      [muiTheme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    buttonsMobile: {
      '& .nav-btn:not(:last-child)': {
        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: '20px',
        },
      },
    },
  }),
  { name: 'GenCampaignHeader' },
);

export default useStyles;
